module.exports = __webpack_public_path__ + "static/media/thumb_anjum.d0f72126.webp";